














import {Component, Prop, Vue} from 'vue-property-decorator'
import {
    RecurringTransactionData,
    BalanceEntryType,
    RecurrenceType
} from "@/util/transactionData";
import {currency} from "@/util/formatter";
import spacetime from "spacetime";

@Component
export default class RecurringTransactionEntry extends Vue {
    @Prop()
    data!: RecurringTransactionData;

    private get formattedAmount(): string {
        return currency(this.data.amount, true);
    }
    
    private get note(): string {
        return this.data?.note || '-';
    }

    private get recurrenceType(): string {
        switch (this.data.recurrenceType) {
            case RecurrenceType.WEEKLY:
                return 'Weekly';
            case RecurrenceType.MONTHLY:
                return 'Monthly';
        }
    }

    private get occurrenceInfo(): string {
        if (this.data.nextOccurrenceDate) {
            const formatted = spacetime(this.data.nextOccurrenceDate).format('numeric-uk').toString();
            return `(next&nbsp;occurrence&nbsp;-&nbsp;${formatted})`
        } else if (this.data.lastOccurrenceDate && !this.data.isActive) {
            const formatted = spacetime(this.data.lastOccurrenceDate).format('numeric-uk').toString();
            return `(last&nbsp;occurrence&nbsp;-&nbsp;${formatted})`
        }

        return '';
    }

    private get amountClass(): string {
        return this.data.type === BalanceEntryType.INCOME ? 'text-green' : 'text-red';
    }
}
